import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { useParams } from "react-router-dom";
import { Navigate } from "react-router-dom-v5-compat";

export const OrgRedirect = () => {
  const dynamicPath = useRouteMapContext((s) => s.routeMap.PROJECT.dynamicPath);

  const params = useParams<{ tenantKey: string; projectKey: string }>();

  return (
    <Navigate
      to={
        dynamicPath({
          projectKey: params.projectKey,
          tenantKey: params.tenantKey,
        }).path
      }
    />
  );
};
